// material-ui

import variousresourceblicon from '../../../assets/images/various-resource-bl.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const VariousResourceBlIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={variousresourceblicon} alt="Various Resource" width="22"  />
    );
};

export default VariousResourceBlIcon;


